import _ from 'lodash-es';

const kformBuilderOptionTagsController = /* @ngInject */ (/** @type {any} */ $scope) => {
	$scope.component.tags = $scope.component.tags || [];
	$scope.tags = _.map($scope.component.tags, tag => ({ text: tag }));

	$scope.addTag = (/** @type {any} */ tag) => {
		if (!$scope.component) {
			return;
		}
		if (!$scope.component.tags) {
			$scope.component.tags = [];
		}
		$scope.component.tags.push(tag.text);
	};

	$scope.removeTag = (/** @type {any} */ tag) => {
		if ($scope.component.tags && $scope.component.tags.length > 0) {
			const tagIndex = $scope.component.tags.indexOf(tag.text);
			if (tagIndex !== -1) {
				$scope.component.tags.splice(tagIndex, 1);
			}
		}
	};
};

export default kformBuilderOptionTagsController;
